import React, { useState } from 'react';
import { ReactComponent as BinSettingsIcon } from 'assets/icons/bin-settings-icon.svg';
import { ReactComponent as BlacklistSettingsIcon } from 'assets/icons/blacklist-rider-settings-icon.svg';
import { ReactComponent as DeliverySettingsIcon } from 'assets/icons/delivery-settings-icon.svg';
import { ReactComponent as LocationSettingsIcon } from 'assets/icons/location-settings-icon.svg';
import { ReactComponent as NotificationSettingsIcon } from 'assets/icons/notifications-alert-settings-icon.svg';
import { ReactComponent as SurgeSettingsIcon } from 'assets/icons/surge-settings-icon.svg';
import SettingsCard from './settings-card';
import SurgeFactorsSideModal from './surge-factors-side-modal';
import BlacklistSettingsModal from './settings-modals';
import { useNavigate } from 'react-router-dom';
import { LOGISTICS_ROUTE_KEYS } from 'utils/constants';
import DeliverySettingsModal from 'components/logistics/surge/delivery-settings/delivery-settings-modal';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

const Settings = () => {
  const navigate = useNavigate();
  const { role } = useRoleContext();
  if (role === ENUM_ROLE.LOGISTICS_ADMIN) navigate(LOGISTICS_ROUTE_KEYS.OVERVIEW);

  const [showDeliverySettingsModal, setShowDeliverySettingsModal] = useState(false);
  const [showSurgeFactorsModal, setShowSurgeFactorsModal] = useState(false);
  const [showBlacklistSettingsModal, setShowBlacklistSettingsModal] = useState(false);

  const surgeFactors = () => {
    setShowSurgeFactorsModal(!showSurgeFactorsModal);
  };
  const deliverySettings = () => {
    setShowDeliverySettingsModal(true);
  };
  const blacklistSettings = () => setShowBlacklistSettingsModal(true);
  const notificationsSettings = () => {
    console.log('notification settings');
  };
  const locationSettings = () => {
    navigate(LOGISTICS_ROUTE_KEYS.LOCATION);
  };
  const binSettings = () => {
    console.log('bin settings');
  };
  const categories = [
    {
      name: 'Surge factors',
      description: 'Update surge factors and values',
      icon: <SurgeSettingsIcon />,
      onClick: surgeFactors
    },
    {
      name: 'Delivery settings',
      description: 'Manage how customers get their orders',
      icon: <DeliverySettingsIcon />,
      onClick: deliverySettings
    },
    {
      name: 'Blacklist settings',
      description: 'Manage blacklist settings and factors',
      icon: <BlacklistSettingsIcon />,
      onClick: blacklistSettings
    },
    {
      name: 'Notification & Alerts',
      description: 'Update surge factors and values',
      icon: <NotificationSettingsIcon />,
      onClick: notificationsSettings
    },
    {
      name: 'Location settings',
      description: 'Add new Foodcourt locations',
      icon: <LocationSettingsIcon />,
      onClick: locationSettings
    },
    {
      name: 'Bin settings',
      description: 'Manage riders in your bin',
      icon: <BinSettingsIcon />,
      onClick: binSettings
    }
  ];
  return (
    <div>
      <div>
        <p className='text-2xl font-semibold'>Settings</p>
        <p className='text-sm'>lorem ipsum dolum sit amil lochdh donotil van der lorem</p>
      </div>
      <hr className='border-gray-border mt-6 mb-10' />
      <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8'>
        {categories?.map(({ name, description, icon, onClick }, index) => (
          <div key={index}>
            <SettingsCard name={name} description={description} icon={icon} onClick={onClick} />
          </div>
        ))}
      </div>
      <hr className='border-gray-border my-8' />
      <DeliverySettingsModal
        show={showDeliverySettingsModal}
        onClose={() => setShowDeliverySettingsModal(false)}
      />

      <SurgeFactorsSideModal show={showSurgeFactorsModal} onClose={surgeFactors} />

      <BlacklistSettingsModal
        show={showBlacklistSettingsModal}
        onClose={() => setShowBlacklistSettingsModal(false)}
      />
    </div>
  );
};

export default Settings;
